import React, { useRef, useEffect, useState } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { t } from '@lingui/macro';
import PulseLoader from '../../pulse-loader';
import Resources from '../../../helpers/resources';
import StudentResult from './student-result/student-result';
import AssignedList from './student-assigned/assigned-list/assigned-list';
import { ERROR_DETECTED } from '../../../containers/course-assign/course-assign-types';
import { Results, StudentIcon } from '../../../helpers/icon-dictionary';
import { getTruncatedName } from '../../../helpers/utils';
import {
  ModalBody,
  StudentDetails,
  StudentName,
  CourseDetails,
  LoaderWrapper,
  TabContainer,
  TabHeading,
  TabbedPanel
} from './student-modal.styled';

import SvgIcon from '../../svg-icon/svg-icon';

export const TABS = {
  RESULTS: 'RESULTS',
  ASSIGNED: 'ASSIGNED'
};

const StudentResultModal = ({ i18n, currentActiveTab }) => {
  const wraperRef = useRef(null);
  const dispatch = useDispatch();
  const [chartData, setChartData] = useState({});
  const [activeTab, setActiveTab] = useState(currentActiveTab);

  const isLoadingResults = useSelector(
    (state) => state.CourseAssignReducer.isLoadingResults
  );
  const studentReport = useSelector(
    (state) => state.CourseAssignReducer.studentResult
  );

  const classroomId = useSelector(
    (state) => state.CourseAssignReducer.activeClass
  );

  const groupId = useSelector((state) => state.CourseAssignReducer.activeGroup);

  const classroomList = useSelector(
    (state) => state.CourseAssignReducer.classrooms
  );

  const classId = classroomList.filter(
    (item) => item.classroomId === classroomId
  );

  const groupName = classId[0].groups.filter(
    (item) => item.groupId === groupId
  );

  useEffect(() => {
    Resources.getChartResult
      .get({ classroomId, groupId })
      .send()
      .then(
        (response) => {
          setChartData(response.data);
        },
        (err) => {
          dispatch({
            type: ERROR_DETECTED,
            payload: err
          });
        }
      );
  }, [classroomId, groupId, dispatch]);

  const fullName = `${studentReport.studentFirstName} ${studentReport.studentLastName}`;

  if (isLoadingResults) {
    return (
      <ModalBody ref={wraperRef}>
        <LoaderWrapper data-testid="Loader">
          <PulseLoader />
        </LoaderWrapper>
      </ModalBody>
    );
  }

  return (
    <ModalBody ref={wraperRef}>
      <StudentDetails>
        <StudentName title={fullName} data-testid="resultmodal-student-name">
          {getTruncatedName(fullName)}
        </StudentName>
        <CourseDetails data-testid="resultmodal-groupname">
          Group name - {groupName[0].name}
        </CourseDetails>
        <CourseDetails data-testid="resultmodal-coursename">
          Course name - {groupName[0].courseName}
        </CourseDetails>
      </StudentDetails>

      <TabContainer>
        <TabHeading
          data-testid="resultmodal-display-results"
          selected={activeTab === TABS.RESULTS}
          onClick={() => {
            setActiveTab(TABS.RESULTS);
          }}
        >
          <SvgIcon icon={Results} />
          {i18n._(t('studentModal.Results')`Results`)}
        </TabHeading>
        <TabHeading
          data-testid="resultmodal-display-assigned"
          selected={activeTab === TABS.ASSIGNED}
          onClick={() => {
            setActiveTab(TABS.ASSIGNED);
          }}
        >
          <SvgIcon icon={StudentIcon} />
          {i18n._(t('studentModal.Assigned')`Assigned`)}
        </TabHeading>
      </TabContainer>

      <TabbedPanel>
        {activeTab === TABS.RESULTS && (
          <StudentResult
            data-testid="student-result"
            i18n={i18n}
            studentReport={studentReport}
            chartData={chartData}
          />
        )}
        {activeTab === TABS.ASSIGNED && (
          <AssignedList
            i18n={i18n}
            assignmentList={studentReport.assignments}
            studentName={fullName}
          />
        )}
      </TabbedPanel>
    </ModalBody>
  );
};

export const viewStudentResultModal = (i18n, activeTab) => ({
  content: <StudentResultModal i18n={i18n} currentActiveTab={activeTab} />,
  id: 0,
  buttons: []
});

StudentResultModal.propTypes = {
  i18n: PropTypes.object.isRequired,
  currentActiveTab: PropTypes.string.isRequired
};

export default StudentResultModal;



// WEBPACK FOOTER //
// ./components/student-list/student-modal/student-modal.js